import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {GetSaoLucasBills, GetSaoLucasBillsModel, GetSaoLucasBillsParams} from 'domain/usecases';

export class RemoteGetSaoLucasBills implements GetSaoLucasBills {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetSaoLucasBillsModel>,
	) {}

	async get({signal, ...params}: GetSaoLucasBillsParams): Promise<GetSaoLucasBillsModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
